import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { AdminService } from "../../services/admin-service";
import { NotifyService } from "../../services/notify-service";

export class JobProgressModalController {
	static $inject = ["$scope", "$q", "$uibModalInstance", "$window", "adminService", "notifyService", "$interval", "jobID", "jobTitle", "progressStatus", "allowJobToCancel", "hideProgress", "showProgressSpinner"];	

	progressIntervalPromise: ng.IPromise<any>;
	progressComplete: number;
	progressFailed: number;
	progressFailedPercentage: number;
	progressTotal: number;
	progressPercentage: number;
	progressMessage: string;
	resultMessage: string;
	progressClass: string = "progress-bar-success";
	progressResultData: string;
	resultMessageFormatter: (event: { data: string }) => string;
	progressMessageFormatter: (event: { data: string }) => string;

	constructor(private $scope: ng.IScope,
		private $q: ng.IQService,
		private $uibModal: ng.ui.bootstrap.IModalServiceInstance,
		private $window: ng.IWindowService,
		private adminService: AdminService,
		private notifyService: NotifyService,
		private $interval: ng.IIntervalService,
		private jobID: string,
		private jobTitle: string,
		private progressStatus: string,
		private allowJobToCancel: boolean,
		private hideProgress: boolean,
		private showProgressSpinner: boolean) {

		if (this.jobID) {
			this.ShowProgress();
		}
	}

	private ShowProgress() {
		this.notifyService.startProgress();
		this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
		this.UpdateProgress();
	}

	private UpdateProgress() {
		this.adminService.getJobState(this.jobID)
			.then((result) => {
				this.progressComplete = result.completed;
				this.progressFailed = result.failed;
				this.progressStatus = result.statusDescription;
				this.progressTotal = result.total;
				this.progressMessage = result.progressMessage;
				this.resultMessage = this.FormatProgressMessage(result.resultMessage);

				this.progressPercentage = (this.progressComplete / this.progressTotal) * 100;
				this.progressFailedPercentage = (this.progressFailed / this.progressTotal) * 100;
				if (this.progressFailed > 0 || result.status === "Failed") {
					this.progressClass = "progress-bar-warning";
				}

				if (result.status === "Done" || result.status === "Failed" || result.status === "Cancelled") {
					this.resultMessage = this.FormatResultMessage(result.resultMessage);
					this.progressResultData = result.progressResultData;
					this.$interval.cancel(this.progressIntervalPromise);
					this.notifyService.endProgress();					
					this.$uibModal.close(result);
				}
			});
	}

	public CancelJob() {
		this.adminService.cancelJob(this.jobID)
			.then((res) => {
				this.$uibModal.dismiss();
			});
	}

	private FormatResultMessage(message: string): string {
		if (this.resultMessageFormatter && message) {
			return this.resultMessageFormatter({ data: message });
		}
		return message;
	}

	private FormatProgressMessage(message: string): string {
		if (this.progressMessageFormatter && message) {
			return this.progressMessageFormatter({ data: message });
		}
		return message;
	}

	public Cancel() {
		this.$uibModal.dismiss();
	}
}


